const makeGrid = (width, height, side) => {
    const SQRT3 = Math.sqrt(3);
    const self = {
        getWidth: () => width,
        
        getHeight: () => height,

        calcActualWidth: cells => side * (1.5 * cells + 0.5),

        calcActualHeight: cells => side * (SQRT3 * cells + SQRT3/2),

        getSide: () => side,

        traverseAll: (callback) => {
            for (let u = 0; u < width; u++) {
                for (let v = 0; v < height; v++) {
                    callback(u, v);
                }
            }
        },

        getArrayIndex: (u, v) => {
            return u + v * width;
        },

        getUVFromArrayIndex: (i) => {
            const u = i % width;
            const v = (i - u) / width;
            return [u, v];
        },

        getStrictlyAdjacent: (u, v) => {
            const potentials = [
                [-1, u % 2 === 0 ? 1 : 0],
                [-1, u % 2 === 0 ? 0 : -1],
                [0, -1],
                [1, u % 2 === 0 ? 0 : -1],
                [1, u % 2 === 0 ? 1 : 0],
                [0, 1]
            ];
            
            let adjacent = [];

            for (let p of potentials) {
                if (u + p[0] >= 0 && u + p[0] < width && v + p[1] >= 0 && v + p[1] < height) {
                    adjacent.push([u + p[0], v + p[1]]);
                }
            }

            return adjacent;
        },

        getMidpoint: (u, v) => {
            return [Math.round(side * (u * 1.5 + 1)), Math.round(side * (v * SQRT3 + (u % 2 === 0 ? SQRT3 : SQRT3/2)))];
        },

        /*getBoundingCorner: (u, v) => {
            return [u * side, v * side];
        },*/

        getPolygon: () => {
            return [
                [-side*1, 0],
                [-side*0.5, -side*SQRT3/2],
                [side*0.5, -side*SQRT3/2],
                [side*1, 0],
                [side*0.5, side*SQRT3/2],
                [-side*0.5, side*SQRT3/2]
            ];
        },

        getCoordinatesAt: (x, y) => {
            const calcDistToMidpoint = uv => {
                const midpoint = self.getMidpoint(uv[0], uv[1]);
                return Math.abs(midpoint[0] - x)*Math.abs(midpoint[0] - x) + Math.abs(midpoint[1] - y)*Math.abs(midpoint[1] - y);
            };

            const guessUV = [Math.floor(x / (side*1.5)), Math.floor(y / (side*SQRT3))];
            let bestHit = {
                uv: guessUV,
                dist: calcDistToMidpoint(guessUV)
            };
            const neighbours = self.getStrictlyAdjacent(guessUV[0], guessUV[1]);
            for (let neighbour of neighbours) {
                const dist = calcDistToMidpoint(neighbour);
                if (dist < bestHit.dist) {
                    bestHit = {
                        uv: neighbour,
                        dist: dist
                    };
                }
            }
            if (bestHit.uv[0] >= 0 && bestHit.uv[1] >= 0 && bestHit.uv[0] < width && bestHit.uv[1] < height) {
                return bestHit.uv;
            } else {
                return undefined;
            }
        }
    };
    return self;
};

export default makeGrid;